<template>
    <div class="lms__user_reward_add">
        <div class="lms__user_reward_add_header">
            <view-actions
                :title="$t('lms.user.achievements.text.addReward')"
                :notify-process="$t('lms.user.achievements.text.cancel')"
                :notify-title="$t('lms.user.achievements.name.reward')"
                :cancel-button-text="$t('lms.user.achievements.buttons.cancel')"
                :submit-button-active="false"
                @emit-notify-cancel-submit="rewardStopEdit"
            />
        </div>
        <div class="lms__user_reward_add_main">
            <div class="container">
                <div class="columns custom--centered">
                    <div class="column is-6-desktop is-10-tablet is-12-mobile">
                        <lms-user-rewards-edit-form/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ViewActions from '@/components/default/shared/ViewActions'
import LmsUserRewardsEditForm from '@/components/lms/user/rewards/edit/LmsUserRewardsEditForm'

export default {
  name: 'lms-user-rewards-add',
  components: {
    ViewActions,
    LmsUserRewardsEditForm
  },
  methods: {
    allowRedirectBeforeRouteLeave: function () {
      this.$eventBus.$emit('achievement-reward-submit')
    },
    rewardStopEdit: function () {
      this.allowRedirectBeforeRouteLeave()
      const routeQuery = this.$route.query
      if (routeQuery.achievementId) {
        this.$router.push({ name: 'lms-user-achievement-edit-reward', params: { id: routeQuery.achievementId } })
      } else {
        this.$router.push({ name: 'lms-user-achievement-list' })
      }
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/user/rewards/_lmsuserrewardsaddedit.scss";
</style>
